import ReportManagementDetailed from "../../features/reportmanagementdetailed";
import { useFilterContext } from "../../hooks/FilterContext";
import { ClientReportProvider } from "../../hooks/ClientReportContext";
import { ClientReportManagementFilterSubHeader } from "../../layouts/ClientReportManagementLayout";
import { useLazySearchReportsQuery } from "../../services/clientreports";

const ReportManagementDetailedPage = () => {
    const { filter, isReady } = useFilterContext();
    return (
        <ClientReportProvider filter={filter} isReady={isReady} query={useLazySearchReportsQuery}>
            <ClientReportManagementFilterSubHeader />
            <section className="px-4 my-3 h-100">
                <ReportManagementDetailed />
            </section>
        </ClientReportProvider>
    );
};

export default ReportManagementDetailedPage;